export default function HelpController(
  $scope,
  $stateParams,
  $timeout,
  $location,
  helpItemsService,
  helpTranslationService
) {
  'ngInject';

  $scope.modules = [];
  $scope.selected = {};

  //get all help modules
  $scope.getModules = function () {
    return helpItemsService.getModules();
  };

  //use to scroll to the content on click
  $scope.gotoAnchor = function (x) {
    $location.hash(x);
  };

  /***
   * function will take modules object then filter the items that user don't have access to it
   * and update the items templateUrl to help pages location
   * return accessible modules array
   */
  let getAccessiblemodules = (modules = {}) => {
    const accessibleModules = Object.keys(modules).reduce((accumulator, key) => {
      const accessibleItems = modules[key].items
        .filter(item => helpItemsService.isAccessible(item.helpitemid))
        //prefix the url from where we are going to load the lelp pages
        .map(item => ({
          ...item,
          templateUrl: `content/help/en/${item.templateUrl}`
        }));
      //will give the user access to the module as long he/she has access to one item in that module
      if (accessibleItems.length) {
        accumulator.push({ ...modules[key], items: accessibleItems });
      }
      return accumulator;
    }, []);

    return accessibleModules;
  };

  let refresh = function () {
    $scope.modules = getAccessiblemodules($scope.getModules());

    //for redirection to specific section
    if ($stateParams.helpItem || $stateParams.helpPage) {
      let modules = $scope.modules;

      //to open the nav sub module based on the page it redirected from
      $scope.selected.header = $stateParams.helpPage;

      //variable to check sub help section exist
      let helpItemExist = false;

      //going through each module to find the sub help section
      for (let key in modules) {
        if (modules[key].id === $stateParams.helpPage) {
          for (let i = 0; i < modules[key].items.length; i++) {
            let item = modules[key].items[i];
            if (item.itemid === $stateParams.helpItem) {
              helpItemExist = true;
              break;
            }
          }
        }
      }

      //default item if none exist
      let helpItem = 'map';
      if (helpItemExist) {
        // if sub help exist go to the section
        helpItem = $stateParams.helpItem;
      } // go to the main section
      else helpItem = $stateParams.helpPage;

      //wait for DOM to load
      $timeout(function () {
        $scope.gotoAnchor(helpItem);
      });
    }
  };

  //load translation content then load the help pages
  const init = () => {
    helpTranslationService.loadHelpTranslation().finally(() => {
      refresh();
    });
  };

  init();

  //for toggling side menu
  $scope.class = function () {
    return helpItemsService.isShowingHelpSideNav() ? 'is-active' : '';
  };
  $scope.click = function () {
    helpItemsService.toggleHelpSideNav();
  };
  $scope.isShowingHelpSideNav = function () {
    return helpItemsService.isShowingHelpSideNav();
  };
  $scope.closeHelpNav = function () {
    helpItemsService.hideHelpSideNav();
  };

  $scope.toggleModule = function (module) {
    if ($scope.selectedModule === module) {
      $scope.selectedModule = null;
    } else {
      $scope.selectedModule = module;
    }
  };

  $scope.moduleStyle = function (module) {
    let style = 'transition: all 0.5s;';

    if (!$scope.isActive(module)) {
      return style;
    }

    style += 'height:' + module.items.length * 40 + 'px;';

    return style;
  };

  $scope.isActive = function (module) {
    return $scope.selectedModule === module;
  };
}
